export const DATE_OPERATORS = {
  IS: 1,
  IS_EQUAL_TO: 2,
  IS_BEFORE: 3,
  IS_AFTER: 4,
  IS_BETWEEN: 5
}
